import React, { useState } from 'react';
import { Button, notification } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { orderExportDetail } from '../../../../store/requests/order';
import { ITEM_TYPE_ORDERS, COURIER_SOURCE } from 'helpers/constants';

const ExportOrderDetailData = ({ payload, disabled }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const orderTypeMap = {
    [ITEM_TYPE_ORDERS.regularOrder]: t('regularOrder'),
    [ITEM_TYPE_ORDERS.changeOrder]: t('changeOrder'),
    RETURN_PICKUP: t('returnOrder'),
  };

  const courierSourceMap = {
    [COURIER_SOURCE.Bringo]: t('Bringo'),
    [COURIER_SOURCE.CepteŞOK]: t('CepteŞOK'),
  };

  const orderChannelMap = {
    POSITIVE: 'ŞOK-Positive',
    TRANSFORMATION: 'ŞOK-Yeni Ecom',
  };

  const handleExport = async () => {
    if (!payload) return;
    setLoading(true);
    try {
      const data = await orderExportDetail(payload);
      const rows = Array.isArray(data) ? data : [];

      if (rows.length === 0) {
        notification.warning({ message: t('warning'), description: t('noData') });
        return;
      }

      const headers = [
        t('orderId'),
        t('orderChannel'),
        t('shipmentStatus'),
        t('slotTime'),
        t('address'),
        t('orderCreatedTime'),
        t('deliveryDate'),
        t('store'),
        t('courierSource'),
        t('shipmentType'),
        t('ADDITIONAL_ORDER'),
      ];

      const csvData = [
        headers,
        ...rows.map((item) => [
          item.customerOrderNumber,
          orderChannelMap[item.channel] ?? item.partner,
          t(item.orderStatus),
          item.timeSlot,
          item.address,
          item.externalCreateTime?.replace('T', ' '),
          item.deliveryDate,
          item.storeCode && item.storeName
            ? `${item.storeCode} - ${item.storeName}`
            : item.storeName || '-',
          courierSourceMap[item.courierSource] || item.courierSource || '-',
          orderTypeMap[item.orderType] || '-',
          item.additional ? t('additionalExists') : t('additionalNotExists'),
        ]),
      ];

      const csvContent =
        '\uFEFF' + csvData.map((row) => row.map((cell) => `"${String(cell ?? '').replace(/"/g, '""')}"`).join(';')).join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'OrderDetails.csv');
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      notification.error({ message: t('error') });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      shape="round"
      title={t('download')}
      icon={<DownloadOutlined />}
      onClick={handleExport}
      disabled={disabled || !payload}
      loading={loading}
    />
  );
};

export default ExportOrderDetailData;
